import { createAction, props } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';

export const Exception = createAction(
  '[Shared][Logger] Exception',
  props<{ error: HttpErrorResponse }>()
);

export const Information = createAction(
  '[Shared][Logger] Information',
  props<{ information:any }>()
);

